module.exports = __webpack_public_path__ + "img/amazulu.a5e2e45e.png";